import settings from '@/content/locales.json'
export type Locale = keyof typeof settings
export const supportedLocales = Object.entries(settings).map(([id, value]) => ({ id: id as Locale, ...value }))
export const defaultLocale: Locale = 'en-CA'
export function normalizeLocale(value?: string | null): Locale | undefined {
  return supportedLocales.find(locale => locale.id.toLowerCase() === value?.toLowerCase())?.id
}
export function browserLocale(): Locale {
  for (const language of navigator.languages || [navigator.language]) {
    const match = supportedLocales.find(locale => locale.id.toLowerCase() === language.toLowerCase() || locale.language === language.split('-')[0])
    if (match) return match.id
  }
  return defaultLocale
}
